module.exports = __webpack_public_path__ + "img/info-dollar-sign.75bb74e2.svg";